import React from "react";
import { ThemeMenu1 } from "../Theme1/Theme1";
import { useParams } from "react-router-dom";

const Theme1 = ({
  orgInfo,
  orgData,
  isVideoPlaying,
  setIsVideoPlaying,
}) => {
  const { orgcode, page } = useParams();
  return (
    <>
      {orgcode && (
        <ThemeMenu1
          orgInfo={orgInfo}
          orgData={orgData}
          isVideoPlaying={isVideoPlaying}
          setIsVideoPlaying={setIsVideoPlaying}
        />
      )}
    </>
  );
};

export { Theme1 };
